import useSWR from 'swr';
import LayerSwapApiClient from '../lib/apiClients/layerSwapApiClient';
function buildDetailedQuoteUrl(args) {
    const { sourceNetwork, sourceToken, destinationNetwork, destinationToken, destinationAddress } = args;
    if (!sourceNetwork || !sourceToken || !destinationNetwork || !destinationToken || !destinationAddress) {
        return null;
    }
    const params = new URLSearchParams({
        source_network: sourceNetwork,
        source_token: sourceToken,
        destination_network: destinationNetwork,
        destination_token: destinationToken,
        destination_address: destinationAddress,
        refuel: String(!!args.refuel),
        use_deposit_address: 'true',
    });
    return `/detailed_quote?${params.toString()}`;
}
export function transformFormValuesToDetailedQuoteArgs(values) {
    return {
        sourceNetwork: values.from?.name,
        sourceToken: values.fromAsset?.symbol,
        destinationNetwork: values.to?.name,
        destinationToken: values.toAsset?.symbol,
        destinationAddress: values.destination_address || undefined,
        refuel: values.refuel,
        useDepositAddress: true,
    };
}
export function useDetailedQuote(args, refreshInterval) {
    const apiClient = new LayerSwapApiClient();
    const url = buildDetailedQuoteUrl(args);
    const { data, error, isLoading, mutate } = useSWR(url, apiClient.fetcher, {
        refreshInterval: refreshInterval ?? 30000,
        dedupingInterval: 5000,
    });
    const bestQuote = data?.data?.[0];
    return {
        detailedQuotes: data?.data,
        bestQuote,
        isLoading,
        error,
        mutate,
    };
}
